import React from "react";
import AccountingPlaceholder from "./AccountingPlaceholder";

const SalesDocument: React.FC = () => (
  <AccountingPlaceholder title="Chứng từ bán hàng" />
);

export default SalesDocument;
